import {  useLocation } from 'react-router-dom';
import React, { useState, useEffect ,useRef } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { useReactToPrint } from 'react-to-print';


function StudentsReport({ studentData, onClose }) {

  const location = useLocation();
  const { selectedDate } = location.state || {};
  const language = localStorage.getItem("language");
  const udiseNumber = localStorage.getItem("udiseNumber");
  const [schoolData, setSchoolData] = useState(null); 
  const [schoollogo, setSchoollogo] = useState(null); 

  const [showModal, setShowModal] = useState(true);
  
console.log("studentData",studentData);

  const formatDate = (date) => {
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, '0'); 
    const month = String(d.getMonth() + 1).padStart(2, '0'); 
    const year = d.getFullYear(); 
    return `${day}-${month}-${year}`;
  };

  const todaysdate = formatDate(new Date());
  const openIndexedDB = () => {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open('SchoolManagementDB', 1); // Use your actual DB name and version
  
      request.onerror = (event) => {
        console.error("IndexedDB error:", event.target.error);
        reject("Error opening IndexedDB");
      };
  
      request.onsuccess = (event) => {
        resolve(event.target.result);
      };
  
      request.onupgradeneeded = (event) => {
        const db = event.target.result;
        
      };
    });
  };

  const fetchSchoolData = async () => {
    if (udiseNumber) {
      try {
        const db = await openIndexedDB();
        const transaction = db.transaction(['schoolData'], 'readonly');
        const objectStore = transaction.objectStore('schoolData');
        const request = objectStore.get(udiseNumber);

        request.onsuccess = (event) => {
          const data = event.target.result;
          if (data) {
            setSchoolData(data);
            setSchoollogo(data.schoolLogo); // Set the logo URL
          }
        };

        request.onerror = (event) => {
          console.error("Error fetching school data:", event.target.error);
        };
      } catch (error) {
        console.error('Error fetching school data:', error);
      }
    }
  };
  useEffect(() => {
    fetchSchoolData(); 
  }, [selectedDate]); 

 
  
    const printRef = useRef();
  
    const handlePrint = useReactToPrint({
      content: () => printRef.current,
      documentTitle: 'Student Details',
      onBeforePrint: () => {
        const style = document.createElement('style');
        style.type = 'text/css';
        style.media = 'print';
        style.innerHTML = `
       
        @page { size: A4 portrait;
        margin:3mm; }
          
          table {
            border: 1px solid black;
            width: 100%;
            border-collapse: collapse;
          }
          th, td {
            border: 1px solid black;
            padding: 5px;
            text-align: left;
          }
          img {
            max-width: 100px;
            max-height: 100px;
          }
          .signature-section {
            margin-top: 50px;
          }
            
        `;
        document.head.appendChild(style);
      },
      onAfterPrint: () => {
        // Optionally clean up print-specific styles
        const styles = document.querySelectorAll('style[media="print"]');
        styles.forEach(style => style.remove());
      }
    });
    
  

  return (
    <div> 
      <div className='main-content-of-page' >
        {showModal && (
          <div style={{
            position: 'fixed',
            top: '0',
            right: '0',
            width: '88%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: '1000',marginTop:'25px',
        

          }}>
            <div style={{
              backgroundColor: '#fff',
              border: '1px solid black',

              borderRadius: '10px',
              width: '850px',
              boxShadow: '0 4px 15px rgba(0, 0, 0, 0.9)',
              maxHeight: '90%',
              overflowY: 'auto',
              position: 'relative',
            }}>

              <button className="registerNewCloseBtn" onClick={onClose}><CloseIcon /></button>
             
              <div style={{padding:'30px'}} className="print-content" ref={printRef}>
              
              <div className="modal-content" >
                <table style={{
                  width: '100%',
                  borderCollapse: 'collapse',
                  fontFamily: 'Arial, sans-serif',
                  border: '1px solid black',
                  borderRadius: '10px',
                  boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
                }}>
                  <thead>
                    {schoolData && (
                      <tr>
                
                      <th colSpan="7" style={{
                          color: 'black',
                          padding: '5px',
                          borderRadius: '10px 10px 0 0',
                          textAlign: 'center',
                          lineHeight: '0.4',
                          borderBottom: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          fontSize: '13px',
                          // position: 'relative' 
                        }}>
                      <div className="school-header-container">
  <div className="school-header2">
    {schoollogo ? <img src={schoollogo} /> : <div></div>}
  </div>
  <div className="school-header">
    <div style={{ marginLeft: "15px" }}>
      <p style={{margin:'7px auto'}}>{schoolData ? schoolData.sansthaName: " "}</p>
      <h5 style={{fontWeight:'600', margin:'10px auto'}}>{schoolData ? schoolData.schoolName : " "}</h5>
      <div className="report-tit">
        {language === 'English' ? 'Taluka' : 'तालुका'}: {schoolData ? schoolData.taluka : " "}, {language === 'English' ? 'District' : 'जिल्हा'}: {schoolData ? schoolData.jilha : " "}
      </div>
      <p className='Monthname' style={{ position: 'absolute', right: '10px', display: 'flex', alignItems: 'center' }}>
        {todaysdate}
        </p>
      <div className="report-title">
        {language === "English" ? "Students Detail" : "विद्यार्थ्यांची माहिती"}
        
      </div>
      
      
    </div>
  </div>
</div>
                         
            <style jsx>{`
          
              .school-header-container {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 100%;
              }
              .school-header2 {
                display: flex;
                align-items: center;
                justify-content: flex-start;
                flex: 0 0 auto; /* Prevent this section from growing */
                margin-right: 10px;
              }
              .school-header2 img {
                max-height: 60px;
              }
              .school-header {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                text-align: center; margin-left:-70px;
                flex: 1 1 auto; /* This makes the school header take available space */
              }
              .school-header h1 {
                font-size: 28px;
                margin: 5px 0;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
              .school-header .report-title {
                
                margin: 5px auto;
              
                width: 140px;
                text-align: center;

                background-color: rgb(37, 39, 41);
                color: white;
                padding: 10px;
                border-radius: 5px;
                font-size: 14px;
              }
              .school-header .report-tit {
                font-size: 14px;
                margin: 5px auto;
                margin-bottom: 14px;
                text-align: center;
              }
              `}
            </style>

                        </th>
                      </tr>
                    )}
                    <tr >
                    <td colSpan={4} style={{ textAlign: 'left', fontSize: '12px',  border: '1px solid black',borderRight:'none' }}>
     
      {studentData.saralId && (
    <>
    SARAL ID: {studentData.saralId} <br />
    </>
  )}
    </td>
    <td colSpan={3} style={{ textAlign: 'right', fontSize: '12px' , border: '1px solid black', borderLeft:'none' }}>
      Book No: {studentData.bookno}
    </td>
    
  </tr>
                    <tr style={{ color: 'black' }}>
                    <td colSpan={1} style={{  maxWidth: '100%', textAlign: 'center', borderRight:'none',border: '1px solid black', }}>
  <img 
    src={studentData.stdPhoto} 
    alt=" " 
    style={{ 
      maxWidth: '100px', 
      maxHeight: '100px',
      width: '100%',
      height: 'auto',
      margin: '0'
    }} 
  />
</td>
                   <td colSpan={3} style={{ borderLeft:'none',  borderRight:'none', textAlign:'left', fontSize:'14px',border: '1px solid black',}}>
                   <p style={{fontWeight:'bold', marginBottom:'0px'}}>{studentData.stdName} {studentData.stdFather} {studentData.stdSurname} </p>
                   <div>
  Academic Year: {studentData.educationalYear} <br />
  Register No.: {studentData.registerNo} <br />
  {studentData.aparId && (
    <>
      APAAR ID: {studentData.aparId} <br />
    </>
  )}
</div>
                   </td>
                   <td colSpan={3} style={{ borderLeft:'none',textAlign:'left', fontSize:'14px',border: '1px solid black'}}>
                   <p  style={{fontWeight:'bold', marginBottom:'0px'}}></p>
                   <div>
                   Admission Class : {studentData.admissionClass} <br/>
                   Current Class : {studentData.currentClass} <br/>
                   Division : {studentData.division} <br/>
                   {studentData.panId && (
    <>
    PEN No: {studentData.panId} <br />
    </>
  )}
                   </div>
                   </td>
                    </tr>
                  </thead>

                  <tbody>
                   
                  
                  <tr style={{ color: 'black'}}>
                   <td  colSpan={3} style={{ borderLeft:'none', borderRight:'none', textAlign:'left', fontSize:'14px',border: '1px solid black'}} >
                   <tr>Gender :  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;{studentData.gender  || "-"}</tr>
                   <tr>Mothers Name :  &nbsp;{studentData.stdMother  || "-"}</tr>
                   <tr>Blood Group :  &nbsp; &nbsp; &nbsp;{studentData.bloodGroup || " - "}</tr>
                   <tr>Adhar No : &nbsp; &nbsp;  &nbsp; &nbsp;  &nbsp; &nbsp;{studentData.adharNo || "-99999999999"}</tr>
                   </td>
                   
                   <td colSpan={4} style={{ borderLeft:'none', borderRight:'none', textAlign:'left', fontSize:'14px', paddingRight:'0',border: '1px solid black'}}>
                   
                   <tr>Mobile No :  &nbsp; &nbsp; &nbsp; &nbsp; { studentData.mobileNo  || "-"}</tr>
                   <tr>Email :  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; {studentData.stdemailId || "-"}</tr>

                   <tr>Date Of Birth :  &nbsp; &nbsp;{formatDate(studentData.dob)  || "-"}</tr>
                   <tr>DOB in Words : &nbsp;{studentData.dobInWords  || "-"}</tr>
                   </td>
                 
                    </tr>


                    <tr style={{ color: 'black' }}>
                   <td  colSpan={3} style={{ borderLeft:'none', borderRight:'none', textAlign:'left', fontSize:'14px',border: '1px solid black',}} >
                   <tr>Mother Tounge : {studentData.motherTounge || " - "}</tr>
                   <tr>Birth Place :   &nbsp; &nbsp; &nbsp;<span style={{marginLeft:'9px'}}></span>{studentData.birthPlace  || "-"}</tr>
                   <tr>Religion : &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;  &nbsp;{studentData.religion  || "-"}</tr>
                   <tr>Caste :&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;   &nbsp;{studentData.caste  || "-"}</tr>
                   <tr>Sub-Caste : &nbsp; &nbsp; &nbsp;  &nbsp;{studentData.subcaste  || "-"}</tr>
                   <tr>Category :  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;  <span style={{marginLeft:'-3px'}}>{studentData.category  || "-"}</span></tr>
                   <tr>Minority :  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;  &nbsp;{studentData.minority ? (language === "English" ? "Yes" : "होय") : (language === "English" ? "No" : "नाही")}</tr>
                   </td>
                   
                   <td colSpan={4} style={{ borderLeft:'none', borderRight:'none', textAlign:'left', fontSize:'14px', paddingRight:'0',border: '1px solid black',}}>
                   
                   <tr>Nationality : {studentData.nationality  || "-"}</tr>
                   <tr>
                   Country :   &nbsp;  &nbsp; { studentData.country  || "-"}</tr>
                   <tr>State :  &nbsp; &nbsp;  &nbsp; &nbsp; &nbsp;{studentData.state  || "-"}</tr>
                   <tr>District :  &nbsp; &nbsp; &nbsp; {studentData.district  || "-"}</tr>
                   <tr >Taluka :  &nbsp; &nbsp; &nbsp; <span style={{marginLeft:'2px'}}>{studentData.taluka  || "-"}</span></tr>
                   <tr>Address :  &nbsp; &nbsp; <span style={{marginLeft:'-3px'}}>{studentData.address  || "-"}</span></tr>
                   <tr>Pincode :  &nbsp; &nbsp; &nbsp;{studentData.pincode  || "-"}</tr>
                   </td>
                 
                    </tr>

                    

                    <tr style={{ color: 'black'}}>
                   <td  colSpan={3} style={{ borderLeft:'none', borderRight:'none', textAlign:'left', fontSize:'14px',border: '1px solid black'}} >
                   <tr>Boarder/Non-Boarder :&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;{studentData.isHosteller==="true" ? (language === "English" ? "Yes" : "होय") : (language === "English" ? "No" : "नाही")}</tr>
                   <tr>Scholarship Holder: &nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp; &nbsp;{studentData.isScolar==="true" ? (language === "English" ? "Yes" : "होय") : (language === "English" ? "No" : "नाही")}</tr>
                   <tr>If Yes, Name Of Scholarship : {studentData.scolarName  || " - "}</tr>
                   </td>
                   
                   <td colSpan={4} style={{ borderLeft:'none', borderRight:'none', textAlign:'left', fontSize:'14px', paddingRight:'0',border: '1px solid black'}}>
                   
                   <tr>Physically challenged :  &nbsp;&nbsp;&nbsp;&nbsp; &nbsp; &nbsp; &nbsp; {studentData.isCWSN ==="true"? (language === "English" ? "Yes" : "होय") : (language === "English" ? "No" : "नाही")}</tr>
                   <tr>If Yes, Category of Disability :  {studentData.disabilityName || "-"}</tr>

                   <tr>RTE Admission :  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;{studentData.isRTE==="true" ? (language === "English" ? "Yes" : "होय") : (language === "English" ? "No" : "नाही")}</tr>
                   
                   </td>
                    </tr>

                    <tr style={{ color: 'black'}}>
                   <td  colSpan={3} style={{ borderLeft:'none', borderRight:'none', textAlign:'left', fontSize:'14px',border: '1px solid black'}} >
                   <tr>Mother's Occupation :&nbsp; &nbsp; &nbsp;{studentData.mOccupation  || "-"}</tr>
                   
                   <tr>Mother's Education:&nbsp;&nbsp; &nbsp;&nbsp; &nbsp; &nbsp;{studentData.mEducation  || "-"}</tr>
                   <tr>Mother's Number: &nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp; &nbsp;{studentData.mMobile  || "-"}</tr>
                   <tr>Annual Family Income:  &nbsp;₹ {studentData.famIncome  || "-"}</tr>
                   </td>
                   
                   <td colSpan={4} style={{ borderLeft:'none', borderRight:'none', textAlign:'left', fontSize:'14px', paddingRight:'0',border: '1px solid black'}}>
                   
                   <tr>father's Occupation :  { studentData.fOccupation || "-"} </tr>
                    <tr>father's Education : &nbsp; &nbsp;{studentData.fEducation  || "-"}</tr>
                   <tr>father's Number :  &nbsp;&nbsp; &nbsp; &nbsp; {studentData.fMobile  || "-"}</tr>

                   
                   
                   </td>
                 
                    </tr>

  <tr >
                    <td colSpan={2} style={{ textAlign: 'left', fontSize: '14px', borderRight:'none' ,border: '1px solid black',}}>
                    Date Of Admission :  {formatDate(studentData.dateOfAdmission)}
    </td>
    <td colSpan={5} style={{ textAlign: 'right', fontSize: '14px',borderLeft:'none' ,border: '1px solid black', }}>
    Previous School: {studentData.prevSchool ||"-"}
    </td>
  </tr>
                  </tbody>
                </table>
                <div className='text-center Certificate-dailyposhan' style={{border: '1px solid black',borderTop:'none' ,paddingTop:'40px'}}>
                  <div className='signature-section' style={{ display: 'flex', justifyContent: 'space-between', margin: '0 auto', padding: '0 20px', fontSize: '13px', width: '70%', alignItems: 'center', marginTop: '10px' }}>
                  
                    <div className='principal-signature' style={{ textAlign: 'left' }}>
                      <p className='president-signature' style={{ textAlign: 'center', marginBottom: '0' }}>
                        {language === "English" ? "Principal" : "मुख्याध्यापक"}
                      </p>
                      <p className='schmgnt'>{language === "English" ? "Signature and Stamp" : "सही व शिक्का"}</p>
                    </div>

                    <div className='principal-signature' style={{ textAlign: 'right' }}>
                      <p className='president-signature' style={{ textAlign: 'center', marginBottom: '0' }}>
                        {language === "English" ? "President" : "अध्यक्ष"}
                      </p>
                     
                    </div>
                  </div>
                </div>
              </div>

</div>

              <div style={{ textAlign: 'right', marginTop: '10px' }}>
              
              <button onClick={handlePrint} style={{
                  padding: '8px 13px',
                  backgroundColor: '#8A1538',
                  color: '#fff',
                  border: 'none',
                  borderRadius: '5px',
                  cursor: 'pointer',
                  fontSize: '16px',
                  boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
                  transition: 'background-color 0.2s ease',
                  marginRight: '30px',
                  marginBottom:'5px'
                }}>
                 Print
                </button>

              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default StudentsReport;

